"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Text = _interopRequireDefault(require("../../../components/Text"));
var _react = _interopRequireDefault(require("react"));
var _FormControlLabel = _interopRequireDefault(require("@mui/material/FormControlLabel"));
var _Checkbox = _interopRequireDefault(require("../../../components/Checkbox"));
var _TextInput = _interopRequireDefault(require("../../../components/TextFields/TextInput"));
var _DateInput = _interopRequireDefault(require("../../../components/TextFields/DateInput"));
var _i18n = _interopRequireDefault(require("../../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../../localization/tokens"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Agreement component for confirming a purchase and providing necessary information.
 *
 * @component
 * @param {boolean} isMasterSite - Indicates whether used in master site or control site.
 * @param {Object} member - Information about the member making the purchase.
 * @param {Object} product - Information about the selected product.
 * @param {Object} purchaseData - Data related to the purchase, including signage information.
 * @param {Function} savePurchaseData - Function to save updated purchase data.
 * @param {Object} confirmationErrors - Errors related to confirmation inputs.
 * @returns {JSX.Element} - The rendered Agreement component.
 * @constructor
 */
var Agreement = function Agreement(_ref) {
  var isMasterSite = _ref.isMasterSite,
    member = _ref.member,
    product = _ref.product,
    purchaseData = _ref.purchaseData,
    savePurchaseData = _ref.savePurchaseData,
    confirmationErrors = _ref.confirmationErrors;
  var styles = {
    signature: {
      fontFamily: 'AntaraDistance !important',
      fontWeight: 'bold',
      fontSize: 20,
      paddingBottom: 0
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !isMasterSite && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true
  }, _i18n["default"].t(_tokens["default"].labels.marketplace.confirmPurchaseInfo)), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: _i18n["default"].t(_tokens["default"].labels.password),
    value: purchaseData.signage.password,
    onChange: function onChange(e) {
      savePurchaseData(_objectSpread(_objectSpread({}, purchaseData), {}, {
        password: e.target.value.toString()
      }));
    },
    secure: true,
    error: confirmationErrors.password,
    fullWidth: true,
    autofocus: true
  })), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: _i18n["default"].t(_tokens["default"].labels.yourName),
    fullWidth: true,
    value: purchaseData.signage.name,
    onChange: function onChange(e) {
      savePurchaseData(_objectSpread(_objectSpread({}, purchaseData), {}, {
        signage: _objectSpread(_objectSpread({}, purchaseData.signage), {}, {
          name: e.target.value.toString()
        })
      }));
    },
    error: confirmationErrors.name
  }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: _i18n["default"].t(_tokens["default"].labels.signature),
    fullWidth: true,
    value: purchaseData.signage.signature,
    onChange: function onChange(e) {
      savePurchaseData(_objectSpread(_objectSpread({}, purchaseData), {}, {
        signage: _objectSpread(_objectSpread({}, purchaseData.signage), {}, {
          signature: e.target.value.toString()
        })
      }));
    },
    customInputStyle: styles.signature,
    error: confirmationErrors.signature
  }), /*#__PURE__*/_react["default"].createElement(_DateInput["default"], {
    label: _i18n["default"].t(_tokens["default"].labels.account.datedOnYYYYMMDD),
    fullWidth: true,
    value: purchaseData.signage.datedOn,
    onChange: function onChange(e) {
      savePurchaseData(_objectSpread(_objectSpread({}, purchaseData), {}, {
        signage: _objectSpread(_objectSpread({}, purchaseData.signage), {}, {
          datedOn: e.target.value.toString()
        })
      }));
    },
    error: confirmationErrors.datedOn
  }), /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
    control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
      checked: purchaseData.signage.acceptedTerms,
      onChange: function onChange() {
        return savePurchaseData(_objectSpread(_objectSpread({}, purchaseData), {}, {
          signage: _objectSpread(_objectSpread({}, purchaseData.signage), {}, {
            acceptedTerms: !purchaseData.signage.acceptedTerms,
            timestampOfAcceptance: new Date().getTime() / 1000
          })
        }));
      },
      value: "Agreement",
      color: "secondary"
    }),
    label: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, product.type.toUpperCase() === 'VOLUNTARY' ? /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      small: true,
      light: true,
      margin: "20px 0 0 0"
    }, _i18n["default"].t(_tokens["default"].labels.marketplace.withdrawalAgreementInfoVoluntary)) : /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      small: true,
      light: true
    }, _i18n["default"].t(_tokens["default"].labels.marketplace.withdrawalAgreementInfoOptional)), product.legalClausesToAccept.length > 0 && product.legalClausesToAccept.map(function (clause) {
      return /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true,
        light: true,
        margin: "5px 0 0 0"
      }, clause[member.language]);
    }))
  }), confirmationErrors.agreement && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    color: "red",
    align: "center"
  }, _i18n["default"].t(_tokens["default"].labels.banking.youMustAcceptTermsError)));
};
var _default = exports["default"] = Agreement;